const SupportedLanguages = ["nl_NL", "en_GB"];

export default SupportedLanguages;
